import React from "react";
import RoutinesView from "../components/RoutinesView";

export default function RoutinesWomen() {
  return <RoutinesView sex="mujer" title="Rutinas para mujeres" />;
}
